/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Detail_Impersonate_User_MessageInputs */

const en_admin_company_detail_impersonate_user_message = /** @type {(inputs: Admin_Company_Detail_Impersonate_User_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do you want to impersonate this user?`)
};

const de_admin_company_detail_impersonate_user_message = /** @type {(inputs: Admin_Company_Detail_Impersonate_User_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möchten Sie sich als dieser Benutzer anmelden?`)
};

/**
* | output |
* | --- |
* | "Do you want to impersonate this user?" |
*
* @param {Admin_Company_Detail_Impersonate_User_MessageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_company_detail_impersonate_user_message = /** @type {((inputs?: Admin_Company_Detail_Impersonate_User_MessageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Detail_Impersonate_User_MessageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_company_detail_impersonate_user_message(inputs)
	return en_admin_company_detail_impersonate_user_message(inputs)
});